import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DprActivityModelReport } from '@report/models';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-report-activities-basic',
  templateUrl: './report-activities-basic.component.html',
  styleUrls: ['./report-activities-basic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportActivitiesBasicComponent {
  @Input({ required: true }) activityModel: DprActivityModelReport;

  StaticMessage = StaticMessage;
}
